<!-- =========================================================================================
  File Name: SimulationSelector.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>

    <div class="rounded-lg w-full" v-if="activeCourseInfo.selected"
         style="background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
         box-shadow: 0px 4px 25px 0px rgba(0,0,0,.1);">
      <div class="knowledge-base-jumbotron-content lg:p-12 md:p-8 sm:p-6 p-4 rounded-lg mb-4"
           style="backdrop-filter: blur(10px); height: 100%;">
        <div class="flex justify-between items-center w-full">
          <div>
            <h5 class="font-light">{{ activeCourseInfo.name }}</h5>
            <h1 class="mb-1 pr-32 text-white font-bold" style="font-size: 2.9rem">Select a Simulation to Play</h1>
            <div class="flex align-middle  items-center">
              <vs-button color="primary" icon-pack="feather" icon="icon-book" class="mr-2"
                         size="small" @click="$router.push('/select-course')">Change Course
              </vs-button>
              <vs-button @click="show_hidden_simulations = !show_hidden_simulations; loadSimulationsData();"
                         class="ml-2" color="danger" v-if="$acl.check('proctor')" type="gradient"
                         size="small">{{ show_hidden_simulations === true ? 'Hide Hidden' : 'Show Hidden' }}
              </vs-button>
            </div>
          </div>
          <img alt="course"
               :src="activeCourseInfo.thumbnail !== null ? activeCourseInfo.thumbnail : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'"
               class="rounded hidden lg:block" style="max-width: 175px; max-height: 175px; width: 30%; height: 30%">
          <img alt="course"
               :src="activeCourseInfo.thumbnail !== null ? activeCourseInfo.thumbnail : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'"
               class="rounded block lg:hidden" style="max-width: 105px; max-height: 105px; width: 30%; height: 30%">
        </div>
      </div>
    </div>

    <div v-if="items_local">
      <!---
      <div class="algolia-header mb-4">
        <div class="flex md:items-end items-center justify-between flex-wrap">

          <p class="lg:inline-flex hidden font-semibold algolia-filters-label">Filters</p>

          <div class="flex justify-between items-end flex-grow">

            <div class="flex flex-wrap">
              <div>
                <feather-icon
                  :svgClasses="{'text-primary stroke-current': currentItemView === 'item-grid-view'}"
                  class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                  icon="GridIcon"
                  @click="setDefaultView('item-grid-view')"/>
                <feather-icon
                  :svgClasses="{'text-primary stroke-current': currentItemView === 'item-list-view'}"
                  class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                  icon="ListIcon"
                  @click="setDefaultView('item-list-view')"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      --->
      <div class="relative clearfix ">
        <!--- FILTERS DISABLED
    <vs-sidebar
      v-model="isFilterSidebarActive"
      :click-not-close="clickNotClose"
      :hidden-background="clickNotClose"
      class="items-no-padding vs-sidebar-rounded background-absolute">

      <div class="p-6 filter-container">

        <h6 class="font-bold mb-3">Filter by Difficulty</h6>
        <ul>
          <li v-for="item in difficulties" :key="item.id" class="flex items-center cursor-pointer py-1">
            <vs-radio v-model="difficulties_active" :vs-value="item.id" color="danger"
                      @change="refine('difficulty', item.id)">{{ item.name }}
            </vs-radio>
          </li>
        </ul>

        <vs-divider/>

        <vs-button color="danger" size="small" @click="refine('clear', {})">Reset Filter</vs-button>
      </div>
    </vs-sidebar>
  --->
        <!--- DISABLED FILTERS <div v-if="items_local" :class="{'sidebar-spacer-with-margin': clickNotClose}" > --->
        <div v-if="items_local">
          <template v-if="currentItemView === 'item-grid-view'">
            <!---   <fade-transition group class="items-grid-view vx-row match-height" tag="div"> --->
            <div class="items-grid-view vx-row match-height">
              <div v-for="item in items_local" :key="item.id"
                   class="vx-col card-width-sims">
                <item-grid-view :item="item">
                  <!--- <template slot="action-buttons">
                    <div class="flex flex-wrap">
                      <div
                        class="item-view-secondary-action-btn bg-success p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                        @click="navigate_to_detail_view(item)">
                        <feather-icon icon="PlayIcon" svgClasses="h-4 w-4"/>
                        <span class="text-sm font-bold ml-2">Play</span>
                      </div>
                    </div>
                  </template> --->
                </item-grid-view>
              </div>
            </div>
            <!---   </fade-transition> --->
          </template>

          <template v-else>
            <!-- SEARCH RESULT -->
            <div v-for="item in items_local" :key="item.id" class="items-list-view mb-base">


              <item-list-view :item="item">

                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">
                  <div class="flex flex-wrap mt-4">
                    <div
                      class="item-view-secondary-action-btn bg-success p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                      @click="navigate_to_detail_view(item)">
                      <feather-icon icon="PlayIcon" svgClasses="h-4 w-4"/>
                      <span class="text-sm font-bold ml-2 ">Play</span>
                    </div>
                  </div>
                </template>
              </item-list-view>

            </div>
          </template>

        </div>
      </div>
    </div>

    <div v-else>
      <div class="simple-spinner">
        <span></span>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  components: {
    ItemGridView: () => import('./components/ItemGridView.vue'),
    ItemListView: () => import('./components/ItemListView.vue')
  },
  data () {
    return {
      isFilterSidebarActive: true,
      clickNotClose: true,
      items: [],
      items_local: null,
      productsTotal: 0,
      paginationPageSize: 500,
      currentPage: 1,
      currentItemView: 'item-grid-view',
      show_hidden_simulations: false,

      difficulties: [
        {id: '0', name: 'Simple'},
        {id: '1', name: 'Easy'},
        {id: '2', name: 'Moderate'},
        {id: '3', name: 'Hard'},
        {id: '4', name: 'Challenging'}
      ],
      difficulties_active: null
    }
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    },
    toValue () {
      return (value, range) => [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max
      ]
    },
    isInWishList () {
      return (id) => this.$store.getters['eCommerce/isInWishList'](id)
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  watch: {
    windowWidth () {
      this.setSidebarWidth()
    }
  },
  methods: {

    refine (type, value) {

      if (type === 'difficulty') {
        this.items_local = this.items.filter(a => a.difficulty === parseInt(value))
      }

      if (this.items_local.length === 0) {
        this.$vs.notify({
          title: 'No Simulations Found',
          text: 'No Simulations with requested criteria found, try another filter.',
          color: 'danger',
          position: 'bottom-right'
        })
      }

      if (this.items_local.length === 0 || type === 'clear') {
        this.items_local = this.items
        this.difficulties_active = undefined
      }
    },

    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true
      }
    },

    setDefaultView (item) {
      localStorage.setItem('simulationSearchView', item)
      this.currentItemView = item
    },

    // GRID VIEW - ACTIONS
    toggleFilterSidebar () {
      if (this.clickNotClose) return
      this.isFilterSidebarActive = !this.isFilterSidebarActive
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    navigate_to_detail_view (item) {
      this.$router.push({name: 'legacy-simulation-starter', params: {simulationId: item.id}})
        .catch(() => {
        })
    },

    loadSimulationsData (page = 0) {

      if (this.activeCourseInfo.selected === false) {
        this.$vs.notify({
          title: 'No Course Selected',
          text: 'Please select a course before practicing',
          color: 'danger',
          position: 'top-right'
        })
        return this.$router.push('/select-course')
      }

      if (page === 0) {
        page = this.currentPage
      }

      let simulations = []

      this.$http.get(`courses/@active/simulation?amount=${this.paginationPageSize}&page=${page}&hidden=${this.show_hidden_simulations}`)
        .then(response => {

          if (response.data.data) {
            simulations = response.data.data
            if (simulations.length === 0) {
              return this.$vs.notify({
                title: 'No Simulations In Course',
                text: 'Please contact us if you believe this is an error',
                color: 'danger',
                position: 'top-right'
              })
            }

            this.items = simulations
            this.items_local = this.items

            /* simulations.forEach((item, index) => {
               setTimeout(() => {
                 this.items.push(item)
                 this.items_local = this.items
               }, index * 35)
             }) */

          }

        }).catch(exception => {

          let error = 'An unknown error occurred while loading simulations'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed To Load Course Simulations',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })

    }
  },
  created () {
    this.setSidebarWidth()

  },
  beforeMount () {
    this.loadSimulationsData()

    if (localStorage.getItem('simulationSearchView') !== null) {
      this.currentItemView = localStorage.getItem('simulationSearchView')
    }

  }
}

</script>


<style lang="scss" scoped>

.html {
  overflow-y: scroll !important;
}

.card-width-sims {
  width: 20%;
}

@media (max-width: 2200px) {
  .card-width-sims {
    width: 25%;
  }
}

@media (max-width: 1800px) {
  .card-width-sims {
    width: 33.333333%;
  }
}

@media (max-width: 1300px) {
  .card-width-sims {
    width: 50%;
  }
}
@media (max-width: 750px) {
  .card-width-sims {
    width: 100%;
  }
}


</style>

